import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorNameResolver: FieldResolver = (metadata: Metadata) =>
  ({ originalAuthorName: metadata.getOriginalAuthorName() } as StreamData)

export default originalAuthorNameResolver
